import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import FormDataCommon from '@/app-core/mixins/form/formDataCommon'
import ContactModel from '@/app-core/api/models/contact/ContactModel'
import API from '@/app-core/api/Api'
import ApiResponseEnum from '@/app-core/api/enums/ApiResponseEnum'

export default {
  name      : 'PageContact',
  components: {},
  directives: {},
  mixins    : [i18nRouteMeta, FormDataCommon],
  props     : {
    pageTitle: {
      type   : String,
      default: ''
    },

    pageContent: {
      type   : String,
      default: ''
    }
  },
  enums    : {},
  dataStore: {},
  dataModel: ContactModel,
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('Auth:Login:Success', this.onLogin)
    this.$bus.$on('Auth:Logout:Success', this.onLogout)
    this.$nextTick(() => {
      this.onLogin()
    })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('Auth:Login:Success', this.onLogin)
    this.$bus.$off('Auth:Logout:Success', this.onLogout)
  },
  destroyed() {
  },
  methods: {
    onLogin() {
      if (this.userIsAuthenticated && this.model) this.model = new ContactModel(this.user.Info)
    },

    onLogout() {
      this.resetForm()
    },

    onContactClick() {
      this.saveFromData()
    },

    saveFromData() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      this.isFormSaving = true

      this.model.Send()
        .then(response => {
          this.handleFormSaveResponse(response)
        })
        .catch(error => {
          this.handleFormSaveResponse(error.response)
        })
        .finally(() => {
          this.isFormSaving = false
        })
    },

    handleFormSaveResponse(response) {
      const data = API.responseData(response) || {}
      const status = response?.data?.status
      const message = data?.Messages

      if (API.isResponseSuccess(response) && data.Success) {
        if (data.Success) {
          this.formSaveSuccess(data)
          this.resetForm()

          this.$bus.$emit('app:show-notification', {
            body   : data.Success,
            type   : 'success',
            icon   : 'mdi-check-circle',
            timeout: 5000
          })
        } else {
          if (status === ApiResponseEnum.VALIDATOR_ERROR) {
            this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
          } else if (status === ApiResponseEnum.GENERIC_ERROR) {
            this.setServerErrorMessages(message)
          } else {
            this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
          }
        }
      } else {
        if (status === ApiResponseEnum.VALIDATOR_ERROR) {
          this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
        } else if (status === ApiResponseEnum.GENERIC_ERROR) {
          this.setServerErrorMessages(message)
        } else {
          this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
        }
      }
    }
  }
}
